import type { Contact, ContactPaymentInstruments } from 'types/contacts'
import { ContactEntity, InstrumentType, RelationshipType } from 'types/contacts'

const BASE_CONTACT: Contact = {
  id: '123',
  name: 'Test Contact',
  defaultReference: '1234567890',
  updatedAt: new Date(),
  createdAt: new Date(),
  relationshipType: RelationshipType.THIRD_PARTY,
  entity: {
    type: ContactEntity.INDIVIDUAL,
    firstName: 'Test',
    lastName: 'Contact',
    dateOfBirth: '1990-01-01',
    address: {
      addressLine1: '123 Main St',
      city: 'Anytown',
      region: 'CA',
      postCode: '12345',
      country: 'US',
    },
  },
  description: 'Test Contact',
}

export const MOCK_CRYPTO_PAYMENT_INSTRUMENT_BTC: ContactPaymentInstruments = {
  contact: {
    ...BASE_CONTACT,
    id: 'c1',
    name: 'Alice',
    description: 'Alice desc',
  },
  paymentInstrument: {
    id: 'ci1',
    type: InstrumentType.CRYPTO,
    currency: 'BTC',
    address: '0xabc',
    network: 'Bitcoin',
    description: 'BTC address',
    updatedAt: '2024-01-01T00:00:00Z',
    createdAt: '2024-01-01T00:00:00Z',
  },
  eligibility: [],
}

export const MOCK_CRYPTO_PAYMENT_INSTRUMENT_ETH: ContactPaymentInstruments = {
  contact: {
    ...BASE_CONTACT,
    id: 'c2',
    name: 'Bob',
    description: 'Bob desc',
  },
  paymentInstrument: {
    id: 'ci2',
    type: InstrumentType.CRYPTO,
    currency: 'ETH',
    address: '0xdef',
    network: 'Ethereum',
    description: 'ETH address',
    updatedAt: '2024-01-01T00:00:00Z',
    createdAt: '2024-01-01T00:00:00Z',
  },
  eligibility: [],
}
